import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GetCarrierInfoRequestParams {
  CarrierKey: number;
}

export interface CarrierInfoResponse {
  [key: string]: unknown;
}

export const getCarrierInfoAPI = (params: GetCarrierInfoRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetCarrierInfo`,
  });
};

export const fetchCarrierInfo = async (params: GetCarrierInfoRequestParams): Promise<CarrierInfoResponse> => {
  const response: AxiosResponse<CarrierInfoResponse> = await getCarrierInfoAPI(params);
  return response.data;
};
